<template>
  <h2
    data-component="sub-header"
    v-font-style="this.$store.getters['ui/getBodyCopyFontDetail']('heavy')"
    v-color="this.$store.getters['ui/getPrimaryColor']"
   >
    {{ text }}
  </h2>
</template>

<script>

export default {
  props: [
    'text'
  ]
}

</script>

<style lang="scss" scoped>

  @import '@/assets/scss/variables.scss';

  [data-component='sub-header'] {
    margin-top:14px;
    margin-bottom:14px;
    color:$pinkish-red;
    font-weight:bold;
    font-size:16px;
  }
</style>
